import { PersonalizationManagementEvent } from "@/services/analytics/events/personalization-management-event";
import { AccountManagementAnalytics, AnalyticsEventType, RegistrationType } from "../models";
import { AdobeBaseEvent } from "./adobe-base-event";
import { Store } from "vuex";
import { AppState } from "@/store";
import { ServicesContainer } from "@/services";

export class AdobePersonalizationManagementEvent extends AdobeBaseEvent {
    event = AnalyticsEventType.PageLoaded;
    account = { ...this.account, loginType: RegistrationType.OrderWeb, accountInteraction: { value: 1 }, registrationType: RegistrationType.OrderWeb } as AccountManagementAnalytics;

    constructor(event: PersonalizationManagementEvent, store: Store<AppState>, services: ServicesContainer) {
        super(store, services);

        this.web.webInteraction = {
          linkClicks: {value: 1},
          type: 'other',
          linkModuleName: 'options_link'
        }

        switch (event.eventType) {
            case 'under18':
              this.under18 = event.value ? '1' : '0';  
              break;
            case 'optOutPers':
              this.optOutPers = event.value ? '1' : '0';
              break;
        }
    }
}